import { Styles } from '@orcar/common-d2c';
import styled, { css } from 'styled-components';

export const OuterWrapper = styled.header<{
  isHomePage: boolean;
  hasShadow?: boolean;
  isMobile?: boolean;
}>`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: ${({ isMobile }) =>
    isMobile ? Styles.WIDTH.MOBILE_LAYOUT : Styles.WIDTH.PC_LAYOUT};
  height: ${({ isMobile }) =>
    isMobile ? Styles.HEIGHT.MOBILE_HEADER : Styles.HEIGHT.PC_HEADER};
  background-color: ${Styles.COLOR.WHITE};
  box-shadow: ${({ hasShadow }) =>
    hasShadow ? '0px 3px 10px rgba(0, 0, 0, 0.1)' : 'none'};
  z-index: 10;

  ${({ isHomePage }) =>
    !isHomePage &&
    css`
      position: fixed;
      top: 0;
      left: 0;
    `}
`;

export const InnerWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: ${({ isMobile }) => (isMobile ? 'center' : 'start')};
  align-items: center;
  gap: 48px;
  width: ${({ isMobile, theme }) =>
    isMobile ? theme.WIDTH.MOBILE_LAYOUT : theme.WIDTH.PC_LAYOUT};
`;

export const Gnb = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const GnbPart = styled.div`
  display: flex;
  gap: 48px;
`;

export const NavLink = styled.span<{
  login?: boolean;
  logo?: boolean;
  color?: string;
}>`
  display: flex;
  align-items: center;
  padding: ${({ logo }) => !logo && '10px'};
  color: ${({ color }) => (color ? color : Styles.COLOR.GREY_01)};
  font-family: 'GmarketSansMedium';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.24px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 27px;
  transform: translateY(-50%);
  z-index: 6;
`;

/** 헤더 로고 — 제주로렌트카 로고 옆에 갤럭시렌트카 로고를 가로로 배치.
    로고 왼쪽 끝을 본문 콘텐츠(1200 컬럼) 라인에 맞춘다(별도 음수 마진 없음). */
export const LogoStack = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
